const IMAGE_BUCKET_HOST = 'https://s3.ca-central-1.amazonaws.com/cdn.mydd.io';
const EPHEMERA_HOST = 'https://ephemera.mirus.io';

export { IMAGE_BUCKET_HOST, EPHEMERA_HOST };
